(() => {
  'use strict';
  const configElement = document.getElementById('StarsideShoppingAccountConfig');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  const key = 'starside:personal-shopping-request';
  try {
    sessionStorage.removeItem('starside:b2b-switch-account');
    sessionStorage.removeItem('starside:b2b-login-intent');
    const timestamp = Number(sessionStorage.getItem(key));
    if (!config.hasCustomer && timestamp) {
      sessionStorage.removeItem(key);
      if (Date.now() - timestamp < 300000 && Date.now() >= timestamp) {
        window.location.replace(config.hubUrl);
        return;
      }
    }
  } catch (_) {}
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-starside-personal-shopping]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    try { sessionStorage.setItem(key, String(Date.now())); } catch (_) {}
  });
})();
